"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
require("@/components/common/menu-item/semantics/menu-item-action");
require("@/components/common/surface");
let AddButton = class AddButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-surface variant="elevated" density="compact">
        <mm-menu-item-action
          icon=${icon_names_1.ICON_NAMES.ADD_CIRCLE}
          label=${this.label}
        ></mm-menu-item-action>
      </mm-surface>
    `;
    }
};
AddButton.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], AddButton.prototype, "label", void 0);
AddButton = __decorate([
    (0, decorators_js_1.customElement)('mm-add-button')
], AddButton);
exports.AddButton = AddButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkLWJ1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImFkZC1idXR0b24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUEyRDtBQUUzRCxvRUFBZ0U7QUFDaEUsb0VBQWlFO0FBQ2pFLHVDQUFvQztBQUc3QixJQUFNLFNBQVMsR0FBZixNQUFNLFNBQVUsU0FBUSxnQkFBVTtJQUFsQzs7UUFNdUIsVUFBSyxHQUFHLEVBQUUsQ0FBQTtJQVl4QyxDQUFDO0lBVkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7OztpQkFHRSx1QkFBVSxDQUFDLFVBQVU7a0JBQ3BCLElBQUksQ0FBQyxLQUFLOzs7S0FHdkIsQ0FBQTtJQUNILENBQUM7O0FBaEJNLGdCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7R0FJbEIsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7d0NBQVc7QUFOM0IsU0FBUztJQURyQixJQUFBLDZCQUFhLEVBQUMsZUFBZSxDQUFDO0dBQ2xCLFNBQVMsQ0FrQnJCO0FBbEJZLDhCQUFTIn0=